import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

const styles = {
  card: {
    bgcolor: 'background.paper',
    border: 1,
    borderColor: 'divider',
    borderRadius: '16px',
    px: 2,
    py: 1.75,
    textAlign: 'left',
  },
  description: (theme) => ({
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightMedium,
    color: 'text.secondary',
    lineHeight: 1.6,
  }),
  title: {
    fontWeight: 'bold',
    color: 'secondary.main',
  },
  callLink: (theme) => ({
    display: 'inline-block',
    mt: 1.5,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    color: 'secondary.main',
    cursor: 'pointer',
    borderBottom: '1px solid currentColor',
    lineHeight: 1.4,
    '&:hover': {
      color: 'primary.main',
      borderBottom: '1px solid currentColor',
    },
  }),
};

const HelpCard = ({title, description, callLabel, onCall}) => (
  <Box sx={styles.card}>
    <Typography sx={styles.description}>
      <Box component='strong' sx={styles.title}>{title}</Box> {description}
    </Typography>
    <Link component='button' type='button' onClick={onCall} sx={styles.callLink}>
      {callLabel}
    </Link>
  </Box>
);

HelpCard.propTypes = {
  callLabel: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onCall: PropTypes.func,
  title: PropTypes.string.isRequired,
};

export default HelpCard;
